/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Shy_Goat_SinkInputs */

const en_jade_shy_goat_sink = /** @type {(inputs: Jade_Shy_Goat_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Participation Groups`)
};

const de_jade_shy_goat_sink = /** @type {(inputs: Jade_Shy_Goat_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilnahmegruppen importieren`)
};

/**
* | output |
* | --- |
* | "Import Participation Groups" |
*
* @param {Jade_Shy_Goat_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_shy_goat_sink = /** @type {((inputs?: Jade_Shy_Goat_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Shy_Goat_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_shy_goat_sink(inputs)
	return de_jade_shy_goat_sink(inputs)
});